import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-your-running-workout-plan',
  templateUrl: './your-running-workout-plan.component.html',
  styleUrls: ['./your-running-workout-plan.component.css']
})
export class YourRunningWorkoutPlanComponent implements OnInit {

  // JSON object for the beginner running plan
  public beginnerRunningPlan =
    [
      {
        "day": "Day 1",
        "workoutType": "Speed Work",
        "workout1": "0.5 mile warmup run,",
        "workout2": "4x400m repeats fast with 1:30 minute recovery,",
        "workout3": "0.5 mile cool down run"
      },
      {
        "day": "Day 2",
        "workoutType": "Medium Run",
        "workout1": "3 mile run easy effort"
      },
      {
        "day": "Day 3",
        "workoutType": "Long Run",
        "workout1": "5 mile run very easy effort"
      },
      {
        "day": "Day 4",
        "workoutType": "Medium Run",
        "workout1": "0.5 mile warmup run,",
        "workout2": "6x200m sprint repeats with 1:00 minute recovery,",
        "workout3": "0.5 mile cool down run"
      },
      {
        "day": "Day 5",
        "workoutType": "Tempo Run",
        "workout1": "0.5 mile warmup run,",
        "workout2": "2 mile tempo run (30 sec slower than 5k race pace),",
        "workout3": "0.5 mile cool down run"
      }
    ]

  // JSON object for the intermediate running plan
  public intermediateRunningPlan =
    [
      {
        "day": "Day 1",
        "workoutType": "Speed Work",
        "workout1": "1 mile warmup run,",
        "workout2": "8x400m repeats fast with 1:30 minute recovery,",
        "workout3": "1 mile cool down run"
      },
      {
        "day": "Day 2",
        "workoutType": "Medium Run",
        "workout1": "5 mile run easy effort"
      },
      {
        "day": "Day 3",
        "workoutType": "Long Run",
        "workout1": "8 mile run very easy effort"
      },
      {
        "day": "Day 4",
        "workoutType": "Medium Run",
        "workout1": "2 mile warmup run,",
        "workout2": "8x200m sprint repeats with 1:00 minute recovery,",
        "workout3": "2 mile cool down run"
      },
      {
        "day": "Day 5",
        "workoutType": "Tempo Run",
        "workout1": "1 mile warmup run,",
        "workout2": "3 mile tempo run (30 sec slower than 8k race pace),",
        "workout3": "1 mile cool down run"
      }
    ]

  // JSON object for the advanced running plan
  public advancedRunningPlan =
    [
      {
        "day": "Day 1",
        "workoutType": "Speed Work",
        "workout1": "4 mile warmup run,",
        "workout2": "12x400m repeats fast with 1:30 minute recovery,",
        "workout3": "2 mile cool down run"
      },
      {
        "day": "Day 2",
        "workoutType": "Medium Run",
        "workout1": "7 mile run easy effort"
      },
      {
        "day": "Day 3",
        "workoutType": "Long Run",
        "workout1": "13 mile run very easy effort"
      },
      {
        "day": "Day 4",
        "workoutType": "Medium Run",
        "workout1": "4 mile warmup run,",
        "workout2": "12x200m sprint repeats with 1:00 minute recovery,",
        "workout3": "2 mile cool down run"
      },
      {
        "day": "Day 5",
        "workoutType": "Tempo Run",
        "workout1": "1 mile warmup run,",
        "workout2": "5 mile tempo run (30 sec slower than 8k race pace),",
        "workout3": "2 mile cool down"
      }
    ]

  constructor() { }

  ngOnInit(): void {
    console.log(this.beginnerRunningPlan);
    console.log(this.intermediateRunningPlan);
    console.log(this.advancedRunningPlan);
  }

}